import { AppThunk } from '@lib/state/types';
import { InstagramActions } from '@lib/state/_actions';
import { FetchPostPayLoad } from '@lib/domain/instagram/interface';

export const fetchPosts =
    (payload: FetchPostPayLoad): AppThunk<Promise<void>> =>
    async (dispatch, _getState, container): Promise<void> => {
        try {
            const result = await container.cradle.instagramRepository.getPost(
                payload,
            );
            const { posts } = result;
            dispatch(InstagramActions.setInstagramPosts(posts || []));
        } catch (error) {
            dispatch(InstagramActions.setInstagramPosts([]));
        }
    };

const InstagramThunks = {
    fetchPosts,
};

export default InstagramThunks;
